module.exports = __webpack_public_path__ + "img/wz.1be18e3e.png";